module.exports = __webpack_public_path__ + "assets/icon-retainer-task-red.b8a5f01c.svg";